export default __webpack_public_path__ + "static/media/job_offer2_s.7e989fea.jpg";